import { getSiteConfig } from '@shared/config';

type BreakToolConfirmationType = 'timeout' | 'self_exclusion';

const BREAK_TOOL_QUERY_KEYS = {
  break: 'break',
  period: 'period',
  source: 'source',
  type: 'type',
} as const;

const BREAK_TYPE_TO_TRACKING_TYPE: Record<BreakToolConfirmationType, string> = {
  timeout: 'timeout',
  self_exclusion: 'self-exclusion',
};

function buildBreakToolConfirmationPath(breakType: BreakToolConfirmationType, period?: string): string {
  const params = new URLSearchParams({ [BREAK_TOOL_QUERY_KEYS.break]: breakType });

  if (period) {
    params.set(BREAK_TOOL_QUERY_KEYS.period, period);
  }

  return `${getSiteConfig().ROUTES.TIME_OFF}?${params.toString()}`;
}

function buildTimeOffTrackingPath(breakType: BreakToolConfirmationType, period?: string): string {
  const params = new URLSearchParams({
    [BREAK_TOOL_QUERY_KEYS.source]: 'my-account',
    [BREAK_TOOL_QUERY_KEYS.type]: BREAK_TYPE_TO_TRACKING_TYPE[breakType],
  });

  if (period) {
    params.set(BREAK_TOOL_QUERY_KEYS.period, period);
  }

  return `${getSiteConfig().ROUTES.TIME_OFF}?${params.toString()}`;
}

type CompleteBreakToolSubmissionArgs = {
  breakType: BreakToolConfirmationType;
  period?: string;
  signOut: (options?: { callbackUrl?: string; redirect?: boolean; logoutRedirectUri?: string }) => Promise<void>;
  router: { push: (href: string) => void };
};

async function completeBreakToolSubmission({ breakType, period, signOut, router }: CompleteBreakToolSubmissionArgs): Promise<void> {
  const { breakToolConfirmation } = getSiteConfig().SAFER_GAMBLING;

  if (!breakToolConfirmation.enabled) {
    router.push(buildTimeOffTrackingPath(breakType, period));
    return;
  }

  const confirmationPath = buildBreakToolConfirmationPath(breakType, period);
  await signOut({ redirect: true, logoutRedirectUri: confirmationPath });
}

export { buildBreakToolConfirmationPath, completeBreakToolSubmission };
export type { BreakToolConfirmationType };
